import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=465ce7ac&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"
import style0 from "./Accordion.scss?vue&type=style&index=0&id=465ce7ac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ce7ac",
  null
  
)

export default component.exports